<template>
  <v-container grid-list-xl>
    <v-layout row wrap>
      <vehicle-control></vehicle-control>
      <vehicle-view></vehicle-view>
    </v-layout>
  </v-container>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import VehicleControl from "@/components/vehicles/vehicleControl";
import VehicleView from "@/components/vehicles/vehicleView";

export default {
  data() {
    return {
      fid: Number(this.$route.query.fid)
    };
  },
  methods: {},
  computed: {
    contractor: Store.getSet({ store: "vehicles", prop: "contractor" })
  },
  mounted() {
    !!this.fid && (this.contractor = this.fid);
  },
  components: {
    VehicleControl,
    VehicleView
  }
};
</script>

<style scoped>
.list-complete-item {
  transition: all 1s;
  display: inline-block;
  margin-right: 10px;
}
.list-complete-enter, .list-complete-leave-to
        /* .list-complete-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
.list-complete-leave-active {
  position: absolute;
}
</style>
